export default "__VITE_ASSET__zQ0Dy9Ua__"